<template>
  <div>
    <PageTitle :title="$gettext('Review')" />
    <v-card class="pa-6" ref="FormReview">
      <div>
        <AvatarComponent size="56" />
        <strong class="ml-3 text-h6 font-weight-bold">{{ fullname }}</strong>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row dense align="center" class="my-3">
          <v-col cols="auto">
            <p class="my-0 mr-2">
              <strong><translate>Choose the language</translate></strong>
            </p>
          </v-col>
          <v-col cols="12" :md="4">
            <LangAutocomplete
              :placeholder="$gettext('Choose language')"
              v-model="formData.language"
              :rules="[(v) => !!v || $gettext('Field is required')]"
            />
          </v-col>
        </v-row>

        <v-row dense class="mb-3">
          <v-col cols="12">
            <p class="my-0">
              <strong><translate>Your review</translate></strong>
            </p>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="formData.content"
              outlined
              :rules="emptyRules"
              required
              :placeholder="$gettext('Type your message')"
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row
          dense
          class="mb-3"
          v-for="(review, index) in reviewList"
          :key="index"
        >
          <v-col cols="12" :md="4" :sm="4">
            <p class="my-0 pt-1">
              <strong>{{ review.name }}</strong>
            </p>
            <em class="caption" v-if="review.desc">( {{ review.desc }} )</em>
          </v-col>
          <v-col cols="12" :md="5" :sm="8">
            <v-slider
              v-model="review.point"
              :tick-labels="ticksLabels"
              :max="5"
              step="0.5"
              ticks="always"
              tick-size="4"
              thumb-color="#179D4E"
              thumb-label="always"
              class="review-slider"
              hide-details
            ></v-slider>
          </v-col>
        </v-row>

        <v-row dense class="mb-3">
          <v-col cols="12">
            <v-btn
              large
              color="primary"
              class="font-weight-bold elevation-0 text-none subtitle-1"
              @click="submit"
            >
              <v-icon class="fas fa-paper-plane pr-3" size="18"></v-icon>
              <translate>Send</translate>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn
              text
              class="elevation-0 text-none grey--text"
              @click="hideWriteReview"
              type="submit"
            >
              <v-icon class="fal fa-arrow-left-long pr-3" size="21"></v-icon>
              <translate>Back</translate>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle";
import LangAutocomplete from "@/components/Forms/LangAutocomplete";
import Vue from 'vue';
export default {
  props: ["item"],
  components: {
    PageTitle,
    LangAutocomplete,
  },
  data() {
    return {
      valid: true,
      emptyRules: [(v) => !!v || Vue.prototype.$gettext("Field is required")],

      ticksLabels: ["0", "", "1", "", "2", "", "3", "", "4", "", "5"],
      formData: {
        language: null,
        content: "",
        point: 5,
      },
    };
  },
  computed: {
    reviewList() {
      return [
        {
          name: this.$gettext("Facilities"),
          key: "facilities",
          desc: this.$gettext("Practice, Lockers, Bathrooms, etc."),
          point: 5,
        },
        {
          name: this.$gettext("Course maintenance"),
          key: "maintenance",
          desc: this.$gettext("greens, fairways, tee-boxes, etc."),
          point: 5,
        },
        {
          name: this.$gettext("Surroundings"),
          key: "surroundings",
          desc: this.$gettext("scenery"),
          point: 5,
        },
        {
          name: this.$gettext("Clubhouse"),
          key: "clubhouse",
          desc: this.$gettext(
            "Welcoming, appearance, atmosphere, Service, restauration/bar, etc."
          ),
          point: 5,
        },
        {
          name: this.$gettext("Value for money"),
          key: "value",
          desc: "",
          point: 5,
        },
      ];
    },
    user() {
      return this.$store.state.auth.user;
    },
    fullname() {
      return this.user.firstName + " " + this.user.lastName;
    },
  },
  methods: {
    hideWriteReview() {
      this.$emit("onHideWriteReview");
      window.scrollTo(0, 0);
    },
    parseReviewRating(val) {
      const review = {};
      let sum = 0;
      for (let i in val) {
        review[val[i].key] = val[i].point;
        sum += val[i].point;
      }
      review.overall = sum / 5;
      return review;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const language = { ...this.formData.language };
        const review = this.parseReviewRating(this.reviewList);
        const data = {
          id: this.formData.id,
          course: this.formData.course,
          content: this.formData.content,
          language: language.id,
          type: POST_TYPE_REVIEW,
          reviewData: review,
        };
        let result = { error: {} };

        if (!data.id) {
          delete data.id;
          result = await this.$store.dispatch("newCourseReview", data);
        } else {
          result = await this.$store.dispatch("updateCourseReview", data);
        }

        if (result.error) {
          this.$toast.alert(result.error.message);
        }
        this.$emit('reloadReviewData')
      } else {
        const el = this.$refs.FormReview.$el;

        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
          });
        }
      }
    },
  },
  created() {
    this.formData = { ...this.item };

    let reviewData = this.formData.reviewData;
    if (reviewData) {
      for (let i in this.reviewList) {
        this.reviewList[i].point = reviewData[this.reviewList[i].key];
      }
    }
  },
};
</script>